export function isDisplayableLvtecArticle(article) {
  if (!article) return false;

  const hasHsArray = Array.isArray(article.hs) && article.hs.length > 0;
  const hasDamagedArray = Array.isArray(article.damaged) && article.damaged.length > 0;

  return Boolean(
    article.plannedQuantity
    || article.return?.ok
    || article.return?.damaged
    || article.return?.hs
    || hasHsArray
    || hasDamagedArray,
  );
}

export function getDisplayableArticles(task) {
  const { articles = [], articlesNonLvtec = [] } = task || {};

  const lvtecArticles = articles.filter(isDisplayableLvtecArticle);
  const nonLvtecArticles = articlesNonLvtec.map((article) => ({
    ...article,
    _id: article._id || article?.file?._id,
    ref: 'NON LVTEC',
    return: {
      ok: 0,
      damaged: 0,
      hs: 0,
      ...(article.return || {}),
    },
    plannedQuantity: 0,
    quantity: 0,
    checked: false,
    substitutes: [],
    hs: [],
    damaged: [],
    isNonLvtec: true,
  }));

  return [...lvtecArticles, ...nonLvtecArticles];
}

export function taskHasUncheckedDisplayableArticles(task) {
  return getDisplayableArticles(task).some((article) => article.checkedSage !== true);
}

export function getOkQuantitySurplus(article) {
  const ok = Number(article?.return?.ok) || 0;
  const quantity = Number(article?.quantity) || 0;
  if (ok <= quantity) return 0;
  return ok - quantity;
}

export function getTotalHsQuantity(article) {
  const returnHsQty = Number(article?.return?.hs) || 0;
  const hsArraySum = Array.isArray(article?.hs)
    ? article.hs.reduce((sum, item) => sum + (Number(item?.quantity) || 0), 0)
    : 0;
  return returnHsQty + hsArraySum;
}

export function getTotalDamagedQuantity(article) {
  const returnDamagedQty = Number(article?.return?.damaged) || 0;
  const damagedArraySum = Array.isArray(article?.damaged)
    ? article.damaged.reduce((sum, item) => sum + (Number(item?.quantity) || 0), 0)
    : 0;
  return returnDamagedQty + damagedArraySum;
}

export const ARTICLE_QUANTITY_TYPE_LABELS = {
  hs: 'HS',
  damaged: 'Réparation',
  ok: 'OK',
};

export function getArticleQuantityByType(article, type) {
  if (type === 'hs') return getTotalHsQuantity(article);
  if (type === 'damaged') return getTotalDamagedQuantity(article);
  if (type === 'ok') return Number(article?.return?.ok) || 0;
  return 0;
}

export function applyArticleQuantityUpdate(article, type, quantity) {
  const qty = Math.max(0, Math.floor(Number(quantity)) || 0);

  if (type === 'ok') {
    return {
      ...article,
      return: { ...article.return, ok: qty },
    };
  }

  if (type === 'damaged') {
    const damagedArraySum = Array.isArray(article?.damaged)
      ? article.damaged.reduce((sum, item) => sum + (Number(item?.quantity) || 0), 0)
      : 0;
    return {
      ...article,
      return: {
        ...article.return,
        damaged: Math.max(0, qty - damagedArraySum),
      },
    };
  }

  if (type === 'hs') {
    const hsArraySum = Array.isArray(article?.hs)
      ? article.hs.reduce((sum, item) => sum + (Number(item?.quantity) || 0), 0)
      : 0;
    return {
      ...article,
      return: {
        ...article.return,
        hs: Math.max(0, qty - hsArraySum),
      },
    };
  }

  return article;
}
